var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.28589C7.44772 3.28589 7 3.66964 7 4.14303H6C4.34315 4.14303 3 5.2943 3 6.71446V15.2859C3 16.706 4.34315 17.8573 6 17.8573H18C19.6569 17.8573 21 16.706 21 15.2859V6.71446C21 5.2943 19.6569 4.14303 18 4.14303L17 4.14303C17 3.66964 16.5523 3.28589 16 3.28589C15.4477 3.28589 15 3.66964 15 4.14303L9 4.14303C9 3.66964 8.55228 3.28589 8 3.28589ZM5 8.42875H19V6.71446C19 6.24107 18.5523 5.85732 18 5.85732H6C5.44772 5.85732 5 6.24107 5 6.71446V8.42875ZM15.8536 10.4461C16.0488 10.2787 16.0488 10.0074 15.8536 9.83999C15.6583 9.67262 15.3417 9.67262 15.1465 9.83999L11.4836 12.9796L9.83634 11.696C9.63201 11.5368 9.31579 11.5497 9.13003 11.7249C8.94428 11.9 8.95934 12.1711 9.16367 12.3303L11.5164 14.1636L15.8536 10.4461Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.6fe8ffc1.svg";
export { ForwardRef as ReactComponent };